import React, { useState } from 'react';
import { Dropdown } from 'primereact/dropdown';
import { RadioButton } from 'primereact/radiobutton';
import { Chip } from 'primereact/chip';
import './single-select-dropdown-chip.scss';

interface DropdownChipProps {
  value: any;
  options: any[];
  onChange: (e: { value: any }) => void;
  placeholder?: string;
  optionLabel?: string;
  filter?: boolean;
  className?: string;
  valueTemplate?: (option: any) => JSX.Element;
  itemTemplate?: (option: any) => JSX.Element;
  disabled?: boolean;
  showRadioButton?: boolean;
  showChip?: boolean;
}

const PrimeReactSingleSelectChip: React.FC<DropdownChipProps> = ({
  value,
  options,
  onChange,
  placeholder = 'Select an option',
  optionLabel = 'label',
  filter = false,
  className = '',
  disabled = false,
  showRadioButton = false,
  showChip = false,
  valueTemplate,
  itemTemplate, // Add itemTemplate to the destructured props
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleDropdownOpen = () => {
    setIsOpen(true);
  };

  const handleDropdownClose = () => {
    setIsOpen(false);
  };

  const handleChipRemove = (event: any): boolean => {
    onChange({ value: null });
    return false;
  };

  const renderOption = (option: any) => {
    if (itemTemplate) {
      return itemTemplate(option);
    }
    return (
      <div
        className="p-field-radiobutton"
        style={{ display: 'flex', alignItems: 'center' }}
      >
        {showRadioButton && (
          <RadioButton
            inputId={option.code}
            name="perspective"
            value={option}
            checked={value && value.code === option.code}
            onChange={() => onChange({ value: option })}
            style={{ marginRight: '5px' }}
          />
        )}
        <label htmlFor={option.code} className="p-radiobutton-label">
          {option[optionLabel]}
        </label>
      </div>
    );
  };

  const renderValue = (option: any) => {
    if (option) {
      if (valueTemplate) {
        return valueTemplate(option);
      }
      if (showChip) {
        return (
          <Chip
            label={option[optionLabel]}
            className="p-mr-2 single-chip"
            removable
            onRemove={handleChipRemove}
          />
        );
      } else {
        return <span>{option[optionLabel]}</span>;
      }
    } else {
      return <span>{placeholder}</span>;
    }
  };

  return (
    <div>
      {!value ? (
        <Dropdown
          value={value}
          onChange={onChange}
          options={options}
          optionLabel={optionLabel}
          placeholder={placeholder}
          filter={filter}
          itemTemplate={renderOption}
          className={`single-chip-dropdown w-full md:w-9rem ${className}`}
          panelClassName="single-select-dropdown-panel"
          onShow={handleDropdownOpen}
          onHide={handleDropdownClose}
          dropdownIcon={isOpen ? 'pi pi-chevron-up' : 'pi pi-chevron-down'}
          disabled={disabled}
        />
      ) : (
        renderValue(value)
      )}
    </div>
  );
};

export default PrimeReactSingleSelectChip;
